import apiService from './api';
class EstadosOSService {
    // Listar todos os estados
    async list() {
        const response = await apiService.get('/configuracoes/estados-os');
        return response.data || [];
    }
    // Buscar estado por ID
    async getById(id) {
        const response = await apiService.get(`/configuracoes/estados-os/${id}`);
        return response.data;
    }
    // Criar novo estado
    async create(data) {
        const response = await apiService.post('/configuracoes/estados-os', data);
        return response.data;
    }
    // Atualizar estado
    async update(id, data) {
        const response = await apiService.put(`/configuracoes/estados-os/${id}`, data);
        return response.data;
    }
    // Excluir estado
    async delete(id) {
        await apiService.delete(`/configuracoes/estados-os/${id}`);
    }
    // Reordenar estados
    async reorder(estados) {
        await apiService.post('/configuracoes/estados-os/reorder', { estados });
    }
}
export default new EstadosOSService();
